<template>
  <div>Here is where some instructional or explanitory text, tips, etc might reside.</div>
</template>

<script>
export default {
  name: 'DefaultAside'
}
</script>
